<template>
  <template-feedback-page></template-feedback-page>
</template>

<script lang="ts">

import templateFeedbackPage from '@/app-template/lib/pages/FeedbackPage.vue';

export default {
  name: "FeedbackPage",
  components: { templateFeedbackPage },
};
</script>